import axios from 'axios'
import { call } from 'file-loader'

// var callback;

var http = axios.create({
  baseURL: process.env.API_BASE_URL,
  headers: {'Content-Type': 'application/json'},
})

var httpupload = axios.create({
    baseURL: process.env.API_BASE_URL,
    headers: {'Content-Type': 'multipart/form-data'},
  })

http.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response.status !== 401) return Promise.reject(error)

  var refreshAndRetry = new Promise(function (resolve) {
    axios.post(process.env.API_BASE_URL + '/account/refresh_token',
    {
      'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      }
    }).then(function (response) {
      localStorage.setItem('refresh_token', JSON.stringify({
        value: response.data.refresh_token,
        expire: null
      }))

      localStorage.setItem('token', JSON.stringify({
        value: response.data.token,
        expire: null
      }))

      return Promise.resolve(response)
    }).then(function (response) {
      var failedRequest = error.config
      failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      axios.request(failedRequest).then(function (retryResponse) {
        resolve(retryResponse)
      })
    })
  })

  return refreshAndRetry
})

function getConfig()
{
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  }
}


//user manajemen

function getNotifSchedules(pagination, callback) {
    var config = getConfig()
  
    http.get('/promotion/notifications?page=' + pagination.current_page, config)
      .then(function (response) {
        callback({
          success: true,
          data: response.data
        })
      }).catch(function (error) {
        callback({
          success: false,
          message: error.message
        })
      })
  }

  function getDetailNotif(id, callback) {
    var config = getConfig()
  
    http.get('/promotion/notification/' + id, config)
      .then(function (response) {
        callback({
          success: true,
          data: response.data
        })
      }).catch(function (error) {
        callback({
          success: false,
          message: error.message
        })
      })
  }

  function submitNotification (dataBody, callback)
  {
    var config = getConfig()

    http.post('/promotion/notification', dataBody, config)
      .then(function (response) {
        callback({
          success: true,
          data: response.data
        })
      }).catch(function (error) {
        callback({
          success: false,
          message: error.message
        })
      })
  }

  

export default
{
    submitNotification,
    getDetailNotif,
    getNotifSchedules
}



// WEBPACK FOOTER //
// ./src/services/notification.js